import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import './unstyledLink.scss';

/**
 *  React router Link element that doesn't change the color or underlining of child elements
 *  that would be applied by the <a> element from Link
 */
const unstyledLink = (props: LinkProps) => {
  const { children, className, ...otherProps } = props;

  return (
    <Link className={`${className ? `${className} ` : ''}unstyled-link`} {...otherProps}>
      {children}
    </Link>
  );
};

export default unstyledLink;
